import { createContext } from 'react';

import type { ReferralContextType } from './types';

export const ReferralContext = createContext<ReferralContextType>({
  referralData: {},
  setReferralData: () => {},
  clearReferralData: () => {},
  isIncorrectLinkError: false,
  setIsIncorrectLinkError: () => {},
});
